module.exports = __webpack_public_path__ + "img/eventsbg.c129b86d.jpg";